"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITopicItemSortField = exports.ISubscriptionPlanPeriodUnit = exports.ISortDirection = exports.IItemSortField = exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType["Boolean"] = "boolean";
    ComponentType["Datetime"] = "datetime";
    ComponentType["SingleLine"] = "singleLine";
    ComponentType["RichText"] = "richText";
    ComponentType["Images"] = "images";
    ComponentType["ItemRelations"] = "itemRelations";
    ComponentType["Location"] = "location";
    ComponentType["ParagraphCollection"] = "paragraphCollection";
    ComponentType["PropertiesTable"] = "propertiesTable";
    ComponentType["Videos"] = "videos";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var IItemSortField;
(function (IItemSortField) {
    IItemSortField["TreePosition"] = "treePosition";
})(IItemSortField = exports.IItemSortField || (exports.IItemSortField = {}));
var ISortDirection;
(function (ISortDirection) {
    ISortDirection["Asc"] = "asc";
    ISortDirection["Desc"] = "desc";
})(ISortDirection = exports.ISortDirection || (exports.ISortDirection = {}));
var ISubscriptionPlanPeriodUnit;
(function (ISubscriptionPlanPeriodUnit) {
    ISubscriptionPlanPeriodUnit["Day"] = "day";
    ISubscriptionPlanPeriodUnit["Week"] = "week";
    ISubscriptionPlanPeriodUnit["Month"] = "month";
    ISubscriptionPlanPeriodUnit["Year"] = "year";
})(ISubscriptionPlanPeriodUnit = exports.ISubscriptionPlanPeriodUnit || (exports.ISubscriptionPlanPeriodUnit = {}));
var ITopicItemSortField;
(function (ITopicItemSortField) {
    ITopicItemSortField["CreatedAt"] = "createdAt";
})(ITopicItemSortField = exports.ITopicItemSortField || (exports.ITopicItemSortField = {}));
//# sourceMappingURL=pim-api.js.map